import { entity, persistence } from 'simpler-state';
import { AppConfig } from '../config/config';

const articlesKey = `${AppConfig.storagePrefix}_articles`;

export const securityArticles = entity<any>(null, [persistence(articlesKey, {})]);
